import './seconddiv.css';
import { MenuItem, FormControl, Select } from '@material-ui/core';
// import IMAGES from '../../../images/images';
import { myTools } from '../../../data';
import { useEffect, useState } from 'react';
// import ImageGallery from 'react-image-gallery';

const  DATE_DIFF = require("date-diff-js");






export default function SecondDiv() {
    const softwareDev = myTools[0].softwaredev.tools;
    const architecture = myTools[1].architecture.tools;
    const productDesign = myTools[2].productDesign.tools;


    const [tools, setTools] = useState(softwareDev);
    const [day, setDay] = useState(598)


    function handleSelect(event) {
        setTools(event.target.value);
    }
    
    let myDate = new Date().toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    console.log("real date>>", myDate);

    
    

    console.log("tools>>", tools);
    console.log("date>>",Date());

    useEffect(() => {
        const date1 = new Date(2020, 4, 26); // 2015-12-1
        let today = new Date(); // 2014-01-1
    
        let  dateDiff = DATE_DIFF(date1, today, 'D').output;
        // console.log("date difssss>>>", dateDiff);
        setDay(dateDiff);
    }, [])
    


    return (
        <div className="aboutWork">
            <div className="aboutWork__box1">
                <div className="aboutWork__textHead">
                    <div className="aboutWork__titleWrapper">
                        <h3>TECHNOLOGIES & TOOLS</h3>
                    </div>
                    <div className="aboutWork__select">
                    <FormControl sx={{ m: 1, minWidth: 150 }}  >
                        <Select
                        onChange={ handleSelect}
                        value={tools}
                        MenuProps={{ PaperProps: { sx: { height: 60 } } }}
                        color="red"
                        >
                            <MenuItem style={{ margin: 15}} value={softwareDev}>Software dev</MenuItem>
                            <MenuItem style={{margin: 15}} value={architecture}>Architecture</MenuItem>
                            <MenuItem style={{margin: 15}} value={productDesign}>Product Design</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                </div>

                <div className="aboutWork__iconsWrapper">
                    <div className="aboutWork__icons">                        
                            { tools.map((d) => (
                                <a href={d.link} target='_blank' rel='noopener noreferrer'>
                                <img src={d.image} alt="" />
                                </a>
                            ))}
                    </div>
                </div>
                <div className="aboutWork__helloWrapper">
                    <h3><span>{day}</span>days since I wrote my first “Hello World”.</h3>
                </div>
                
            </div>
        </div>
    )
}
